<template>
  <div class="text-center ma-2">
    <v-snackbar
        :value="content.snackbar"
    >
      {{ content.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="close"
        >
          关闭
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Message",
  props: {
    content: {
      type: Object,
      default: () => {
        return {
          snackbar: false,
          text: '',
        }
      }
    },
    // snackbar: {
    //   type: Boolean,
    //   default: () => {
    //     return false
    //   }
    // },
    // text: {
    //   type: String,
    //   default: undefined
    // }
  },
  methods: {
    close() {
      this.content.snackbar = false
    }
  }
}
</script>

<style scoped>

</style>